<template>
  <nav
    class="bg-white border-b border-gray-200 px-4 py-2.5 dark:bg-gray-800 dark:border-gray-700 fixed left-0 right-0 top-0 z-50">
    <div class="flex flex-wrap justify-between items-center">
      <div class="flex justify-start items-center">
        <button @click="$emit('toggle-sidebar')"
          class="p-2 mr-2 text-gray-600 rounded-lg cursor-pointer md:hidden hover:text-gray-900 hover:bg-gray-100 focus:bg-gray-100 dark:focus:bg-gray-700 focus:ring-2 focus:ring-gray-100 dark:focus:ring-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">
          <svg v-if="!isSidebarOpen" class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd"
              d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h6a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
              clip-rule="evenodd"></path>
          </svg>
          <svg v-else class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clip-rule="evenodd"></path>
          </svg>
        </button>
        <a :href="$url('/')" class="flex items-center justify-start">
          <img v-if="branch && branch.logo_url" :src="branchLogoUrl" alt="Branch Logo"
            class="h-12 w-auto max-w-[150px] sm:max-w-[180px] md:max-w-[200px] lg:max-w-[220px] object-contain" />
          <img v-else-if="instance && instance.logo_url" :src="instanceLogoUrl" alt="Instance Logo"
            class="h-12 w-auto max-w-[150px] sm:max-w-[180px] md:max-w-[200px] lg:max-w-[220px] object-contain" />
          <img v-else src="/img/jamLMS-logo.png"
            class="h-12 w-auto max-w-[180px] sm:max-w-[180px] md:max-w-[200px] lg:max-w-[220px] object-contain" />
        </a>
      </div>

      <div class="flex items-center lg:order-2 space-x-3">
        <!-- View As toggle button -->
        <button v-if="!$store.getters.isLearner" @click="toggleView" type="button"
          class="inline-flex items-center px-4 py-3 text-sm font-semibold text-white !bg-[#0F5C54] rounded-full hover:!bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
          aria-label="Toggle between Admin and Learner views">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24"
            stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M12 11H4m15.5 5a.5.5 0 0 0 .5-.5V8a1 1 0 0 0-1-1h-3.75a1 1 0 0 1-.829-.44l-1.436-2.12a1 1 0 0 0-.828-.44H8a1 1 0 0 0-1 1M4 9v10a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1h-3.75a1 1 0 0 1-.829-.44L9.985 8.44A1 1 0 0 0 9.157 8H5a1 1 0 0 0-1 1Z" />
          </svg>
          {{ isAdminView ? "View as Learner" : "View as Admin" }}
        </button>

        <!-- Profile button -->
        <button type="button"
          class="flex items-center mx-3 text-sm !bg-primary-700 rounded-full md:mr-0 dark:focus:ring-gray-600 px-3 py-1.5"
          id="user-menu-button" aria-expanded="false" data-dropdown-toggle="dropdown">
          <img class="w-9 h-8 rounded-full" src="/img/jamcoding-icon.jpg" alt="user photo" />
          <span class="ml-2 text-white font-medium dark:text-gray-300 truncate capitalize hidden sm:block"
            id="user-name">{{ userName }}</span>
        </button>

        <!-- Profile Dropdown -->
        <div
          class="hidden z-50 my-4 w-56 text-base list-none bg-white divide-y divide-gray-100 shadow dark:bg-gray-700 dark:divide-gray-600 rounded-xl"
          id="dropdown">
          <div class="py-3 px-4">
            <span class="block text-sm font-semibold text-gray-900 dark:text-white">{{ userName }}</span>
            <span class="block text-sm text-gray-900 truncate dark:text-white">{{ userEmail }}</span>
          </div>
          <ul class="py-1 text-gray-700 dark:text-gray-300" aria-labelledby="dropdown">
            <li>
              <router-link :to="$routeWithBranch('User Profile')"
                class="flex items-center py-2 px-4 text-sm hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">My
                profile</router-link>
            </li>
          </ul>

          <ul class="py-1 text-gray-700 dark:text-gray-300" aria-labelledby="dropdown">
            <li>
              <router-link :to="$routeWithBranch('My Courses')"
                class="flex items-center py-2 px-4 text-sm hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                <svg class="mr-2 w-5 h-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd"
                    d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z"
                    clip-rule="evenodd"></path>
                </svg>
                My Courses
              </router-link>
            </li>
            <li>
              <router-link :to="$routeWithBranch('Course Catalog')"
                class="flex items-center py-2 px-4 text-sm hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                <svg class="mr-2 w-5 h-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M7 3a1 1 0 000 2h6a1 1 0 100-2H7zM4 7a1 1 0 011-1h10a1 1 0 110 2H5a1 1 0 01-1-1zM2 11a2 2 0 012-2h12a2 2 0 012 2v4a2 2 0 01-2 2H4a2 2 0 01-2-2v-4z">
                  </path>
                </svg>
                Course Catalog
              </router-link>
            </li>
          </ul>

          <ul class="py-1 text-gray-700 dark:text-gray-300" aria-labelledby="dropdown">
            <!-- Sign Out Button -->
            <li>
              <a @click.prevent="signOut" href="#"
                class="block py-2 px-4 text-sm hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">Sign
                out</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { Dropdown } from 'flowbite';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      isSidebarOpen: false,
    };
  },
  mounted() {
    // Initialize all dropdowns
    const dropdownElements = document.querySelectorAll('[data-dropdown-toggle]');
    dropdownElements.forEach((triggerEl) => {
      const targetEl = document.getElementById(triggerEl.getAttribute('data-dropdown-toggle'));
      new Dropdown(targetEl, triggerEl);
    });
  },
  computed: {
    ...mapGetters({
      user: 'getUser',
      branch: 'getBranch',
      instance: 'getInstance',
    }),
    userName() {
      return this.user.first_name + ' ' + this.user.last_name;
    },
    userEmail() {
      return this.user ? this.user.email : '';
    },
    branchLogoUrl() {
      return this.branch && this.branch.logo_url
        ? `${process.env.VUE_APP_API_URL}${this.branch.logo_url}`
        : null;
    },
    instanceLogoUrl() {
      return this.instance && this.instance.logo_url
        ? `${process.env.VUE_APP_API_URL}${this.instance.logo_url}`
        : null;
    },
    isAdminView() {
      const path = this.$route.path.toLowerCase();
      const segments = path.split('/').filter(Boolean);
      return !segments.includes('learner');
    },
  },
  methods: {
    async signOut() {
      try {
        // Optional: make an API call to logout endpoint if needed
        // await axios.post(`${process.env.VUE_APP_API_URL}/logout`);

        // Clear any stored tokens or session information
        localStorage.removeItem('token'); // if using local storage
        sessionStorage.clear(); // or clear session if stored there

        // Redirect to login page
        this.$routerPushWithBranch('Login');
      } catch (error) {
        console.error('Error signing out:', error);
      }
    },
    toggleView() {
      const path = this.$route.path.toLowerCase();
      const segments = path.split('/').filter(Boolean);
      const branchSlug = segments[0] === 'branch' ? segments[1] : null;

      const targetPath = this.isAdminView
        ? (branchSlug ? `/branch/${branchSlug}/learner/dashboard` : '/learner/dashboard')
        : (branchSlug ? `/branch/${branchSlug}/dashboard` : '/dashboard');

      this.$router.push({ path: targetPath });
    }

  },
};
</script>
